import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex items-center space-x-2 cursor-pointer" }
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Box, _mergeProps({
      as: "button",
      type: "button"
    }, _ctx.$attrs, {
      id: _ctx.id,
      color: _ctx.modelValue ? 'blue' : 'red',
      variant: "light",
      role: "switch",
      "aria-checked": String(_ctx.modelValue),
      "aria-labelledby": `${_ctx.id}-label`,
      class: "inline-flex items-center border border-current rounded-md p-1 focus:ring-2 focus:ring-offset-1 focus:ring-current",
      onClick: _ctx.toggle
    }), {
      default: _withCtx(() => [
        _createVNode(_component_Box, {
          as: "span",
          color: _ctx.modelValue ? 'blue' : 'transparent',
          class: _normalizeClass(["px-1 rounded-md", { 'shadow-lg': _ctx.modelValue }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.trueLabel), 1)
          ]),
          _: 1
        }, 8, ["color", "class"]),
        _createVNode(_component_Box, {
          as: "span",
          color: _ctx.modelValue ? 'transparent' : 'red',
          class: _normalizeClass(["px-1 rounded-md", { 'shadow-lg': _ctx.modelValue }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.falseLabel), 1)
          ]),
          _: 1
        }, 8, ["color", "class"])
      ]),
      _: 1
    }, 16, ["id", "color", "aria-checked", "aria-labelledby", "onClick"]),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("label", {
        id: `${_ctx.id}-label`
      }, _toDisplayString(_ctx.label), 9, _hoisted_2)
    ])
  ]))
}